import createStyles from '@material-ui/core/styles/createStyles'
import { Theme } from '@material-ui/core'
import { padding } from 'common/utils/styles'

export default ({ spacing, breakpoints }: Theme) =>
  createStyles({
    section: {
      marginBottom: spacing.unit * 3
    },
    title: {
      backgroundColor: 'white',
      marginBottom: 1,
      justifyContent: 'space-between'
    },
    paginationContainer: {
      justifyContent: 'flex-end',
      backgroundColor: 'white'
    },
    [breakpoints.down('xs')]: {
      mainContainer: {
        padding: padding(0, spacing.unit * 2)
      },
      paginationContainer:{
        justifyContent: 'center'
      }
    }
  })
